/**
 * BGT-8094: users flagged `forceV3Host` by the API (OTP / shared-report users created by a
 * radar share) belong on the V3 SPA host. When such a user opens this V2 app they have no
 * navigation items here and would end on the forbidden page, so the router sends them to
 * the SPA root instead; the SPA's home route then takes them to the shared-radar portal.
 *
 * The SPA url is `VUE_APP_TERMINAL_MODULE_URL` (the same url the V3 iframe host uses). On
 * acc/prod it shares this app's origin (`https://app…/v3/`), so the check is a path-prefix
 * check on the full href, not an origin check.
 */
export function resolveV3HostRedirect(opts: {
	forceV3Host: boolean | undefined
	spaUrl: string | undefined
	currentHref: string
}): string | null {
	if (!opts.forceV3Host) return null

	const spaUrl = (opts.spaUrl ?? '').trim()
	if (spaUrl === '') return null

	const prefix = spaUrl.replace(/\/+$/, '')
	const current = opts.currentHref.replace(/\/+$/, '')
	if (current === prefix || current.startsWith(prefix + '/')) return null

	return spaUrl
}
